import React, { useEffect, useState, useRef } from "react";
import TransferForm from "./transferForm";

export default function ShowSend({ OnClose, chatData, seatNumber, numSeats }) {
  const [isVisible, setIsVisible] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(OnClose, 300);
  };

  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleClose();
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-20 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={handleClickOutside}
    >
      <div
        ref={modalRef}
        className={`w-full border border-gray-300 rounded-t-2xl bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          isVisible ? "translate-y-0" : "translate-y-full"
        }`}
        style={{ height: "60%" }}
        onClick={(e) => e.stopPropagation()} // prevent modal content click from bubbling
      >
        <div className="mt-2">
          <div className="text-center text-xs font-medium">
            <p>TRANSFER TICKETS</p>
          </div>
        </div>

        <div className="px-4 mt-2 text-md border-t border-gray-700 pt-4">
          <p className="font-medium">
            {numSeats} {numSeats > 1 ? "Tickets" : "Ticket"} Selected
          </p>

          {chatData?.seat_no === "0" ? (
            <p>
              Sec <span className="font-semibold">{chatData?.section}</span> Row{" "}
              <span className="font-semibold">{chatData?.row}</span> Seat{" "}
            </p>
          ) : (
            <p>
              Sec <span className="font-semibold">{chatData?.section}</span> Row{" "}
              <span className="font-semibold">{chatData?.row}</span> Seat{" "}
              {seatNumber.map((seat) => (
                <span key={seat} className="font-semibold">
                  {seat}
                  {seat !== seatNumber[seatNumber.length - 1] ? ", " : ""}
                </span>
              ))}
            </p>
          )}
        </div>

        <div
          className="px-4 mt-6 text-gray-700 overflow-y-scroll scroll-smooth"
          style={{ height: "56%" }}
        >
          {/* <div>
            <div>
              <p className="font-semibold text-md">First Name</p>
              <input
                type="text"
                required
                placeholder="First Name"
                className="w-full h-10 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold text-md">Last Name</p>
              <input
                type="text"
                required
                placeholder="Last Name"
                className="w-full h-10 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold text-md">Email or Mobile Number</p>
              <input
                type="email"
                placeholder="Email or Mobile Number"
                required
                className="w-full h-10 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold text-md">Note</p>
              <textarea
                rows={3}
                type="text"
                required
                className="w-full h-24 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
              />
            </div>
          </div> */}

          <TransferForm seatNumber={seatNumber} />
        </div>

        {/* Bottom Action Bar */}
        {/* h-40 was removed from class */}
        <div className="fixed bottom-0 left-0 w-full flex flex-col justify-end  px-5 text-gray-800 transition-opacity duration-200 ">
          <div className="flex pb-6 justify-between items-center">
            <p
              className="text-sm font-medium text-blue-500"
              onClick={handleClose}
            >
              {" "}
              &lt; BACK{" "}
            </p>
            <button className="text-sm  bg-blue-600 p-2 text-white ">
              TRANSFER {numSeats} {numSeats > 1 ? "TICKETS" : "TICKET"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
